<div class="migration-page">
  <div class="page-topbar">
    <wm-common-button
      class="back-button"
      [data]="{
        text: 'BACK',
        variant: 'basic',
        onClick: cancel.bind(this)
      }"
    ></wm-common-button>
  </div>

  <div class="migration-header">
    <wm-common-text
      class="page-title"
      [data]="{ text: 'Create Workflow Migration', fontWeight: 500 }"
    ></wm-common-text>
    <wm-common-text
      class="page-subtitle"
      [data]="{
        text: 'Create a migration record, upload your files, and prepare the workflow blueprint for Janus migration.'
      }"
    ></wm-common-text>
  </div>

  <div *ngIf="success" class="page-banner success">
    <wm-common-text
      [data]="{ text: 'Workflow migration record created successfully.' }"
    ></wm-common-text>
  </div>

  <div *ngIf="errorMessage" class="page-banner error">
    <wm-common-text [data]="{ text: errorMessage }"></wm-common-text>
  </div>

  <app-loader *ngIf="loading || saving"></app-loader>

  <div class="create-grid" *ngIf="!loading && !saving">
    <section class="migration-card form-card">
      <div class="card-header-row">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'Migration Details', fontWeight: 500 }"
        ></wm-common-text>
      </div>

      <div class="card-body">
        <div class="info-block">
          <wm-common-text
            class="field-label"
            [data]="{ text: 'Jurisdiction', fontWeight: 600 }"
          ></wm-common-text>
          <wm-common-text
            [data]="{
              text: migrationProcessing.jurisdiction || context.client?.name || ''
            }"
          ></wm-common-text>
        </div>

        <div class="field-group">
          <wm-common-textfield
            name="sourceSystem"
            [(ngModel)]="migrationProcessing.sourceSystem"
            [data]="{
              label: 'Project Name',
              placeholder: 'Enter project or workflow name (e.g., Dog License, Building Permit)',
              required: true,
              helperText: 'This becomes the workflow name used during migration.'
            }"
          ></wm-common-textfield>
        </div>

        <div class="field-group upload-group">
          <wm-common-text
            class="field-label"
            [data]="{ text: 'Metadata File', fontWeight: 600, required: true }"
          ></wm-common-text>
          <wm-upload
            buttonText="Select Metadata File"
            validDocumentTypes="json"
            [pathSegments]="['migration-processing', uploadKey]"
            (fileUploaded)="onMetadataFileUploaded($event)"
            (fileDeleted)="onMetadataFileDeleted()"
            [key]="uploadKey + '-metadata'"
            [allowMultipleFiles]="false"
            category="MigrationProcessing"
            [deleteStoredDocument]="false"
            [showUploadedFilesList]="true"
          ></wm-upload>
          <wm-common-text
            class="helper-text"
            [data]="{
              text: 'JSON Metadata File (Blueprint): Defines field types, validations, options, and conditional logic. Uses MatchedTemplateCode to link with CSV Template Codes. Organized by Activities and Fields.'
            }"
          ></wm-common-text>
          <div class="download-links">
            <div class="download-link-row">
              <a
                href="assets/sample-migration-metadata-comprehensive.json"
                download="sample-migration-metadata-comprehensive.json"
                target="_blank"
              >
                Download Sample Metadata File
              </a>
              <span>Comprehensive example with all supported features</span>
            </div>
            <div class="download-link-row">
              <a
                href="assets/sample-migration-metadata-renewable.json"
                download="sample-migration-metadata-renewable.json"
                target="_blank"
              >
                Download Renewable Workflow Sample
              </a>
              <span>Example renewable workflow with expiration formula</span>
            </div>
          </div>
        </div>

        <div
          class="validation-card"
          *ngIf="metadataValidationStatus"
          [class.valid]="
            !metadataValidationStatus.isValidating &&
            metadataValidationStatus.isValid &&
            metadataValidationStatus.errors.length === 0
          "
          [class.invalid]="
            !metadataValidationStatus.isValidating &&
            metadataValidationStatus.errors.length > 0
          "
          [class.pending]="metadataValidationStatus.isValidating"
        >
          <wm-common-text
            *ngIf="metadataValidationStatus.isValidating"
            [data]="{ text: 'Validating metadata file...' }"
          ></wm-common-text>

          <ng-container *ngIf="!metadataValidationStatus.isValidating">
            <wm-common-text
              *ngIf="
                metadataValidationStatus.isValid &&
                metadataValidationStatus.errors.length === 0
              "
              [data]="{
                text: 'Basic Metadata Validation Passed!',
                fontWeight: 500
              }"
            ></wm-common-text>
            <wm-common-text
              *ngIf="
                metadataValidationStatus.isValid &&
                metadataValidationStatus.errors.length === 0
              "
              class="validation-message"
              [data]="{
                text: 'All data entity types are supported. Comprehensive validation (field references, activity order, conditional logic) will run when you create the migration.'
              }"
            ></wm-common-text>

            <div *ngIf="metadataValidationStatus.errors.length > 0">
              <wm-common-text
                [data]="{ text: 'Metadata validation failed.', fontWeight: 500 }"
              ></wm-common-text>
              <ul class="validation-list">
                <li *ngFor="let error of metadataValidationStatus.errors">
                  {{ error }}
                </li>
              </ul>
            </div>

            <div
              *ngIf="
                metadataValidationStatus.warnings.length > 0 &&
                metadataValidationStatus.errors.length === 0
              "
            >
              <wm-common-text
                [data]="{
                  text: 'Metadata validation produced warnings.',
                  fontWeight: 500
                }"
              ></wm-common-text>
              <ul class="validation-list">
                <li *ngFor="let warning of metadataValidationStatus.warnings">
                  {{ warning }}
                </li>
              </ul>
            </div>

            <button
              type="button"
              class="details-toggle"
              (click)="showMetadataValidationDetails = !showMetadataValidationDetails"
            >
              {{
                showMetadataValidationDetails ? 'Hide details' : 'Show details'
              }}
            </button>

            <div
              class="validation-details"
              *ngIf="showMetadataValidationDetails"
            >
              <div>
                <wm-common-text
                  [data]="{ text: 'Supported Types', fontWeight: 600 }"
                ></wm-common-text>
                <div class="chip-list">
                  <span
                    class="chip success"
                    *ngFor="let item of metadataValidationStatus.supportedTypes"
                  >
                    {{ item }}
                  </span>
                </div>
              </div>
              <div *ngIf="metadataValidationStatus.unsupportedTypes.length > 0">
                <wm-common-text
                  [data]="{ text: 'Unsupported Types', fontWeight: 600 }"
                ></wm-common-text>
                <div class="chip-list">
                  <span
                    class="chip warning"
                    *ngFor="
                      let item of metadataValidationStatus.unsupportedTypes
                    "
                  >
                    {{ item }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="field-group upload-group">
          <wm-common-text
            class="field-label"
            [data]="{ text: 'Application Data File', fontWeight: 600 }"
          ></wm-common-text>
          <wm-upload
            buttonText="Select Application Data File"
            validDocumentTypes="json"
            [pathSegments]="['migration-processing', uploadKey]"
            (fileUploaded)="onApplicationDataFileUploaded($event)"
            (fileDeleted)="onApplicationDataFileDeleted()"
            [key]="uploadKey + '-appdata'"
            [allowMultipleFiles]="false"
            category="MigrationProcessing"
            [deleteStoredDocument]="false"
            [showUploadedFilesList]="true"
          ></wm-upload>
          <wm-common-text
            class="helper-text"
            [data]="{
              text: 'Application Data File (Content - Optional): Contains actual application data to import. Organized by Application ID to Activity Name to Field Values. Use after workflow is created.'
            }"
          ></wm-common-text>
          <div class="download-links">
            <div class="download-link-row">
              <a
                href="assets/sample-application-data-comprehensive.json"
                download="sample-application-data-comprehensive.json"
                target="_blank"
              >
                Download Sample Application Data File
              </a>
              <span>Example application data with multiple applications</span>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <wm-common-button
            class="primary-action"
            [data]="{
              text: 'CREATE WORKFLOW MIGRATION',
              variant: 'basic',
              disabled: !canCreate,
              onClick: saveMigrationProcessing.bind(this)
            }"
          ></wm-common-button>
          <wm-common-button
            [data]="{
              text: 'CANCEL',
              variant: 'basic',
              onClick: cancel.bind(this)
            }"
          ></wm-common-button>
        </div>
      </div>
    </section>

    <aside class="side-panel">
      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'Migration Overview', fontWeight: 500 }"
        ></wm-common-text>
        <h4>What is Workflow Migration?</h4>
        <p>
          Workflow Migration helps you transfer your permit workflows from a
          legacy system into GeoPermits. You'll provide three coordinated files
          that work together to recreate your workflow structure and data.
        </p>
        <h4>What You'll Need</h4>
        <ul>
          <li><strong>Jurisdiction:</strong> Which jurisdiction/client this workflow belongs to</li>
          <li><strong>Project Name:</strong> A descriptive name for the workflow (e.g., "Dog License", "Building Permit")</li>
          <li><strong>Metadata File:</strong> JSON file defining activities, fields, data entity types, and properties</li>
          <li><strong>Application Data:</strong> (Optional) Your existing applications to migrate</li>
        </ul>
      </section>

      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'How the Files Work Together', fontWeight: 500 }"
        ></wm-common-text>
        <div class="numbered-card-block">
          <div class="numbered-title-row">
            <span class="number-badge success">1</span>
            <strong>JSON Metadata File</strong>
          </div>
          <p>The <em>workflow blueprint</em> that defines:</p>
          <ul>
            <li>Data entity types (text, dropdown, date, etc.)</li>
            <li>Validation rules and requirements</li>
            <li>Options for list-based data entities</li>
            <li>Conditional visibility and logic</li>
            <li>Activity structure and organization</li>
          </ul>
          <p class="muted-note"><strong>Format:</strong> JSON file with Activities and Fields structure</p>
        </div>
        <div class="numbered-card-block">
          <div class="numbered-title-row">
            <span class="number-badge info">2</span>
            <strong>Application Data File</strong>
          </div>
          <p>The <em>application repository</em> that contains:</p>
          <ul>
            <li>Existing applications from your legacy system</li>
            <li>Data organized by application ID</li>
            <li>Activity-based data grouping</li>
          </ul>
          <p class="muted-note"><strong>Future Feature:</strong> Application data import is coming soon</p>
        </div>
      </section>

      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'Migration Process', fontWeight: 500 }"
        ></wm-common-text>
        <p>The migration workflow:</p>
        <ol>
          <li>
            <strong>Upload &amp; Parse Metadata</strong>
            <p>System automatically parses JSON metadata to identify activities and fields, creating editable Migration Processing Data Entities</p>
          </li>
          <li>
            <strong>Review &amp; Edit Data Entities</strong>
            <p>Review generated data entities, adjust labels, template codes, and target activities. Reorder fields and organize by sections</p>
          </li>
          <li>
            <strong>Execute Migration</strong>
            <p>System builds workflow activities using your edited data entity mappings, creating data entities with proper types and validations. Routes from metadata are processed to create workflow navigation and conditional routing with automatic Decision Activity creation</p>
          </li>
          <li>
            <strong>Verify Workflow</strong>
            <p>Test the created workflow, verify activities and data entities are configured correctly</p>
          </li>
          <li>
            <strong>Migrate Application Data</strong>
            <p>(Coming Soon) Import existing application data into the new workflow structure</p>
          </li>
        </ol>
      </section>

      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'Example: Customizing Data Entities', fontWeight: 500 }"
        ></wm-common-text>
        <p><strong>How "Dog Breed" gets migrated:</strong></p>
        <div class="example-step example-step-primary">
          <strong>1. Metadata Parsed:</strong>
          <p>Field "BreedID" in activity "DOG DETAILS"</p>
          <p>Creates data entity with Label: "BreedID", Template Code: "Breed"</p>
        </div>
        <div class="example-arrow">↓</div>
        <div class="example-step example-step-warning">
          <strong>2. You Edit:</strong>
          <p>Change Label to "Dog Breed"</p>
          <p>Assign to Target Activity: "Dog Information"</p>
        </div>
        <div class="example-arrow">↓</div>
        <div class="example-step example-step-success">
          <strong>3. Migration Creates:</strong>
          <p>Dropdown data entity labeled "Dog Breed" in "Dog Information" activity with breed options from metadata</p>
        </div>
      </section>

      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'File Requirements', fontWeight: 500 }"
        ></wm-common-text>
        <h4>Metadata JSON Structure:</h4>
        <ul>
          <li>Contains an Activities array with all workflow activities</li>
          <li>Each activity contains a Fields array for its data entities</li>
          <li>MatchedTemplateCode property identifies data entities</li>
          <li>Type property determines the data entity control type (for fields) or activity type (for activities)</li>
          <li>Routes property defines workflow routing and conditional logic</li>
          <li>Conditions in routes support complex business logic with field comparisons</li>
        </ul>
        <h4>Supported Data Entity Types:</h4>
        <div class="type-chip-list">
          <span class="type-chip">text</span>
          <span class="type-chip">textarea</span>
          <span class="type-chip">number</span>
          <span class="type-chip">decimal</span>
          <span class="type-chip">currency</span>
          <span class="type-chip">date</span>
          <span class="type-chip">datetime</span>
          <span class="type-chip">time</span>
          <span class="type-chip">today</span>
          <span class="type-chip">dropdown</span>
          <span class="type-chip">checkbox</span>
          <span class="type-chip">radio</span>
          <span class="type-chip">email</span>
          <span class="type-chip">phone</span>
          <span class="type-chip">file</span>
          <span class="type-chip">image</span>
          <span class="type-chip">signature</span>
          <span class="type-chip">group</span>
          <span class="type-chip">table</span>
          <span class="type-chip">row</span>
          <span class="type-chip">formattedtext</span>
          <span class="type-chip">calculated</span>
        </div>
        <p class="muted-note">These data entity types are validated during metadata upload</p>
      </section>

      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'Supported Activity Types', fontWeight: 500 }"
        ></wm-common-text>
        <p>Activities can be specified in metadata using the "Type" property. Supported types:</p>
        <div class="two-column-list">
          <ul>
            <li><strong>form</strong> - Standard data entry form (default)</li>
            <li><strong>payment</strong> - Payment processing</li>
            <li><strong>printtemplate</strong> - Document generation</li>
            <li><strong>print</strong> - Alias for printtemplate</li>
            <li><strong>signoff</strong> - Approval/signature step</li>
            <li><strong>callworkflow</strong> - Invoke another workflow</li>
            <li><strong>email</strong> - Send email notifications</li>
          </ul>
          <ul>
            <li><strong>parcelsearch</strong> - Parcel lookup</li>
            <li><strong>review</strong> - Review activity</li>
            <li><strong>inspection</strong> or <strong>consolidated-inspection</strong> - Consolidated inspection</li>
            <li><strong>request-inspection</strong> - Request inspection</li>
            <li><strong>schedule-inspection</strong> - Schedule inspection</li>
            <li><strong>complete-inspection</strong> - Complete inspection</li>
            <li><strong>simple-inspection</strong> - Simple inspection</li>
            <li><strong>required-user</strong> - Required user assignment step</li>
            <li><strong>end</strong> or <strong>complete</strong> - End workflow</li>
          </ul>
        </div>
        <p class="muted-note">If no type is specified, defaults to "form". Decision activities are created automatically by the routing engine when conditions are specified.</p>
      </section>

      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'Workflow Routing', fontWeight: 500 }"
        ></wm-common-text>
        <h4>Routing Features</h4>
        <ul>
          <li>Specify target activities for workflow progression</li>
          <li>Add conditional routing based on field values</li>
          <li>Automatic Decision Activity creation for complex routing</li>
          <li>Support for multiple routes with different conditions</li>
          <li>Customize decision activity names with <code>RouteActivity</code> property</li>
        </ul>
        <h4>Route Properties</h4>
        <ul>
          <li><code>Name</code> - Descriptive name for the route</li>
          <li><code>ToActivity</code> - Target activity name (required)</li>
          <li><code>Conditions</code> - Array of conditions to evaluate</li>
          <li><code>LogicalOperator</code> - "AND" or "OR" for combining conditions</li>
          <li><code>RouteActivity</code> - Optional custom screen name for the decision activity created when routes have conditions</li>
        </ul>
        <h4>Example Route Configuration</h4>
        <pre class="route-example" ngNonBindable>
&#123;
  "ActivityName": "Application Form",
  "Routes": [
    &#123;
      "Name": "Needs Review",
      "ToActivity": "Manager Review",
      "RouteActivity": "Application Review Decision",
      "Conditions": [
        &#123;
          "Field": "ApplicationValue",
          "Operator": "GREATER_THAN",
          "Value": "10000"
        &#125;
      ]
    &#125;,
    &#123;
      "Name": "Auto Approve",
      "ToActivity": "Approval",
      "Conditions": []
    &#125;
  ]
&#125;
        </pre>
      </section>

      <section class="migration-card info-card">
        <wm-common-text
          class="card-title"
          [data]="{ text: 'Next Steps', fontWeight: 500 }"
        ></wm-common-text>
        <p>After creating this migration record:</p>
        <ol>
          <li>System automatically parses metadata and creates data entities</li>
          <li>You'll be redirected to the migration processing list</li>
          <li>Open your migration to review Migration Processing Data Entities</li>
          <li>Edit labels, template codes, and target activities inline</li>
          <li>Reorder entities and organize by section as needed</li>
          <li>Workflow routing is configured from metadata Routes property</li>
          <li>Execute the migration to build the GeoPermits workflow with routing</li>
          <li>Verify the workflow, routing logic, and mark as complete</li>
        </ol>
      </section>
    </aside>
  </div>
</div>
